angular.module('reporting.dashboards.filters')
    .service('pageSearch', function () {
    'use strict';
    return function (pages, _searchString) {
        var searchString = (_searchString || '').toLowerCase();
        return _.filter(pages, function (page) {
            var description = (page.name || page.description || '').toLowerCase();
            var inDescription = _.contains(description, searchString);
            var inPageId = _.contains(page._id.toLowerCase(), searchString) && !_.contains('page', searchString);
            return inDescription || inPageId;
        });
    };
});
